import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesPreview from "./components/ServicesPreview";
import AboutPreview from "./components/AboutPreview";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesPreview />
      <AboutPreview />
      <CTASection />
      <Footer />
    </div>
  );
}
